import { render } from "@/components/organisms/individualDiagCode/IndividualDiagCode.html?vue&type=template&id=dea5cfda&external"
import script from "@/components/pages/obd/individual/dtc/ObdDtc.js?vue&type=script&lang=js&external"
export * from "@/components/pages/obd/individual/dtc/ObdDtc.js?vue&type=script&lang=js&external"

import "@/components/organisms/individualDiagCode/IndividualDiagCode.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__